import * as React from "react";
import { ClientContext } from "@app/admin/contexts/ClientContext";
import { orderBy } from "lodash";
import { MultiselectItem, MultiselectOnChangeResponse, QESMultiSelect } from "@app/shared/qes-standards/forms/Multiselect";
import { CheckboxStateEnum } from "@app/shared/qes-standards/forms/Checkbox";
import { ClientRoleModel } from "@app/client";

interface ClientRolesProps {
  disabled?: boolean;
}

export const ClientRoles: React.FC<React.PropsWithChildren<ClientRolesProps>> = (props: ClientRolesProps) => {
  const clientContext = React.useContext(ClientContext);

  const selectedOptions = React.useMemo(() => clientContext.authorizedRoles.map((r) => r.name), [clientContext.authorizedRoles]);

  const roleOptions = React.useMemo(() => {
    const roleOptions: { [key: string]: MultiselectItem } = {};
    if (clientContext.availableRoles) {
      clientContext.availableRoles.forEach((r) => Object.assign(roleOptions,
        {
          [r.name]: {
            currentState: selectedOptions.find((so) => so === r.name) ? CheckboxStateEnum.Checked : CheckboxStateEnum.Unchecked,
            displayValue: r.name,
          }
        }));
    }
    return roleOptions;
  }, [clientContext.availableRoles, selectedOptions]);

  const updateRoles = (response: MultiselectOnChangeResponse) => {
    const selectedRoles = response.checkedKeys;
    const newRoles = selectedRoles.map((role) => {
      const matchedRoleModel = clientContext.availableRoles.find((r) => r.name === role);
      return matchedRoleModel;
    }).filter((r) => !!r);
    clientContext.setAuthorizedRoles(orderBy(newRoles.map<ClientRoleModel>((r) => ({ clientDefault: false, name: r.name, questViewerGuestDefault: false, resourceAdminGuestDefault: false, roleId: r.roleId, roleType: r.roleType, userDefault: false })), (r) => r.name, "asc"));
  }

  return (
    <div className="col-12 px-2">
      <QESMultiSelect
        containerClassName="mb-3"
        disabled={props.disabled}
        errorText="At least one role must be selected."
        label="Authorized Roles"
        onChange={updateRoles}
        options={roleOptions}
        required={true}
        testId="new-client__roles"
        isValid={clientContext.validationObject["authorizedRoles"]}
      />
    </div>
  );
}
